interface MidFunnelCTAProps {
  onCtaClick: () => void;
}

export default function MidFunnelCTA({ onCtaClick }: MidFunnelCTAProps) {
  return (
    <section className="py-14 md:py-16" style={{ backgroundColor: '#F7FAF8', borderTop: '1px solid #E4EDE8', borderBottom: '1px solid #E4EDE8' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 md:gap-10">
            {[
              { icon: 'ri-time-line', value: '20 Min.', text: 'pro Woche reichen' },
              { icon: 'ri-user-heart-line', value: '1:1', text: 'Betreuung garantiert' },
              { icon: 'ri-gift-line', value: '0 €', text: 'für das Probetraining' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-4">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'rgba(26,92,61,0.08)' }}
                >
                  <i className={`${item.icon} text-lg`} style={{ color: '#1A5C3D' }}></i>
                </div>
                <div>
                  <div className="font-bold text-xl leading-none" style={{ fontFamily: 'Playfair Display, serif', color: '#1A5C3D' }}>
                    {item.value}
                  </div>
                  <div className="text-gray-500 text-xs mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {item.text}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 flex-shrink-0">
            <button
              onClick={onCtaClick}
              className="text-white font-semibold text-sm px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap w-full sm:w-auto"
              style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1E6B47')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1A5C3D')}
            >
              Probetraining anfragen →
            </button>
            <span
              className="text-gray-400 text-xs whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              kostenlos · unverbindlich
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
